// @flow
import { appQueryParameters } from '@clubmed/utils';
import createAction from 'Store/utils/createAction';
import { convertLocationToURI } from 'Utils/uri/uriUtils';
import { navigateInBookingEngine } from 'Views/booking/BookingEngine.utils';

const SELECT_PROPOSAL = 'SELECT_PROPOSAL';
const CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return createAction(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(
  proposalId: string,
  location: BookingRouterLocation,
  history: RouterHistory,
) {
  const updatedUri = convertLocationToURI(location).setQuery(
    appQueryParameters.booking.selectedProposalId,
    proposalId,
  );

  navigateInBookingEngine({ location: updatedUri, history, replace: true });

  return createAction(SELECT_PROPOSAL, { proposalId });
}

export { CLEAR_SELECTED_PROPOSAL, SELECT_PROPOSAL, selectProposal, clearSelectedProposal };
